<template>
  <div class="session-activity-handler" />
</template>

<script>
/**
 * Handle updates in the current session, such as page changes and inactivity detection
 */

// Vuex and utils
import { SEND_MESSAGE } from '@/store/modules/socket/action-types';
import SocketMessages from '@/utils/classes/SocketMessages';
import SPage from '@/utils/classes/SPage';

export default {

  name: 'SessionActivityHandler',

  data() {
    return {
      inactiveTimeout: null,
      idleDuration: 20 * 60,
      isActive: true,
    };
  },

  computed: {
    /** Number: ID of the current page if found in SPage */
    pageIdFromRoute() {
      // Found a page match using route path
      if (SPage.fromLink[this.$route.path] && SPage.fromLink[this.$route.path].id) {
        return SPage.fromLink[this.$route.path].id;
      }
      // Find a page match using original route path
      if (this.$route.matched.length && this.$route.matched[0].path) {
        const { path } = this.$route.matched[0];
        if (SPage.fromLink[path] && SPage.fromLink[path].id) {
          return SPage.fromLink[path].id;
        }
      }
      return 0;
    },
    /** Boolean: Whether the socket is currenly connected or not */
    socketConnected() {
      return this.$store.state.socket.isConnected;
    },
  },

  watch: {
    $route(to, from) {
      // Set session update
      if (this.pageIdFromRoute) {
        this.sendSocketMessage({ pageId: this.pageIdFromRoute });
      }
    },
    socketConnected(isConnected, wasConnected) {
      if (isConnected && !wasConnected) {
        this.resetTimeout(null, true);
      }
    },
  },

  created() {
    // Moving the mouse or touching the screen should prevent going inactive
    document.addEventListener('mousemove', this.resetTimeout);
    document.addEventListener('mousedown', this.resetTimeout);
    document.addEventListener('touchmove', this.resetTimeout);
    document.addEventListener('touchstart', this.resetTimeout);
    document.addEventListener('touchend', this.resetTimeout);
    document.addEventListener('keypress', this.resetTimeout);
    if (this.socketConnected && this.pageIdFromRoute) {
      this.resetTimeout(null, true);
    }
  },

  beforeDestroy() {
    document.removeEventListener('mousemove', this.resetTimeout);
    document.removeEventListener('mousedown', this.resetTimeout);
    document.removeEventListener('touchmove', this.resetTimeout);
    document.removeEventListener('touchstart', this.resetTimeout);
    document.removeEventListener('touchend', this.resetTimeout);
    document.removeEventListener('keypress', this.resetTimeout);
    clearTimeout(this.inactiveTimeout);
  },

  methods: {
    /** Cancel the timeor and reset it */
    resetTimeout(evt, forceActiveMsg = false) {
      if (!this.isActive || forceActiveMsg) {
        this.isActive = true;
        this.sendSocketMessage({ isActive: 1, pageId: this.pageIdFromRoute });
      }
      clearTimeout(this.inactiveTimeout);
      this.inactiveTimeout = setTimeout(() => {
        if (!this.$store.state.meeting.isMeetingInProgress) {
          this.isActive = false;
          this.sendSocketMessage({ isActive: 0, pageId: this.pageIdFromRoute });
        }
      }, this.idleDuration * 1000);
    },
    sendSocketMessage(params) {
      this.$store.dispatch(`socket/${SEND_MESSAGE}`, { ...params, msg: SocketMessages.SESSION_MSGS.ACTIVITY });
    },
  },
};
</script>

<style lang="scss">
.session-activity-handler {
  display: none;
}
</style>
